import './ScheduleViewSwitch.module.less'
import { Radio } from 'antd'

export default function ScheduleViewSwitch({
  value = '',
  onChange = () => null,
  options = [
    ['Add Class', ''],
    ['Edit Class', '/my'],
  ],
}) {
  return (
    <Radio.Group
      className="schedule-view-switch"
      value={value}
      onChange={onChange}
      optionType="button"
      buttonStyle="solid"
      options={options.map(([label, suffix]) => ({ label, value: suffix }))}
    />
  )
}
